import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';
import { LOANS_AND_BONDS_GROUPS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/constants.ts';
import { LoansAndBondsGroup } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/LoansAndBondsGroup.tsx';
import type { ILoansAndBondsSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/types.ts';
import { useDocumentGenerationOptions } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/hooks/useDocumentGenerationOptions.ts';
import type { TFinancialConditionFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { formatCertificateDate } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const LoansAndBondsSection: React.FC<ILoansAndBondsSectionProps> = ({ disabled }) => {
  const { watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const hasNoLoansAndBonds = watch('hasNoLoansAndBonds');
  const reportDate = formatCertificateDate(watch('reportDate'));
  const { shortBankOptions, currencyOptions, isBanksLoading, isCurrenciesLoading } =
    useDocumentGenerationOptions();

  if (!borrowerType) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        5. Отримані позики, випущені облігації
      </Typography>

      <Typography variant="body2">{`Станом на: ${reportDate || '—'}`}</Typography>

      <FormCheckbox
        name="hasNoLoansAndBonds"
        label="Позик і облігаційних позик немає"
        disabled={disabled}
        formControlLabelProps={{ sx: documentGenerationFormStyles.checkbox }}
      />

      {!hasNoLoansAndBonds &&
        LOANS_AND_BONDS_GROUPS.map((group) => (
          <LoansAndBondsGroup
            key={group.name}
            {...group}
            disabled={disabled}
            lenderOptions={shortBankOptions}
            currencyOptions={currencyOptions}
            isBanksLoading={isBanksLoading}
            isCurrenciesLoading={isCurrenciesLoading}
          />
        ))}
    </Box>
  );
};
